export const STORE_PREFIX = 'admin_company_';